import React, { Component } from 'react'
import '../App.css'
import { withTranslation } from 'react-i18next'
import { getJson, deleteJson } from '../helpers/RequestsHelper'

import AccountConnectComponent from './AccountConnectComponent'
import ApplicationIcon from './ApplicationIcon'

class AccountsList extends Component {

    state = {
        loading: true
    }

    constructor(props) {
        super(props)
        this.onAccountUpdate = this.onAccountUpdate.bind(this)
    }

    componentDidMount() {
        this.fillMyApps(this.props.provider);
    }

    async fillMyApps() {
        const accounts = await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/myapps");

        this.setState(({ accounts : accounts, loading: false }));
    }

    onAccountUpdate(account) {
        var oldState = this.state
        var index = oldState.accounts.findIndex(a=>a.accountId === account.accountId)
        oldState.accounts[index] = account
        this.setState(oldState)
    }

    onDelete = async (event) => {
        const accountId = event.target.dataset.accountid
        
        var oldState = this.state
        oldState.accounts = oldState.accounts.filter(a=>a.accountId !== accountId)
        this.setState(oldState)

        await deleteJson(process.env.REACT_APP_SERVER_BASE_URL + "/myapps/" + accountId)
    }

    render() {
        const { t } = this.props;

        if (this.state.loading) {
            return <div className="spinner-border" role="status">
                <span className="sr-only">{t("loading")}</span>
            </div>
        }

        let accountItems = []

        const accounts = this.state.accounts
        if (accounts) {
            for (let i = 0; i < accounts.length; i++) {
                const account = accounts[i];
                const accountId = account.accountId
                const popupId = "popup" + accountId
                const hashPopupId = "#" + popupId
                const popupLabelId = "delete" + this.state.myFlowId

                const iconPath = `/images/${account.type}.png`
                accountItems.push( 
                    <div className="d-flex flex-row align-items-center" key={accountId} >
                        <div className="large-icon"><img className="app-icon-image" src={iconPath} alt="" /></div>
                        <div className="p-2 large-icon-div w-270" >{account.name}</div>
                        <div className="p-2"><AccountConnectComponent account={account} onUpdate={this.onAccountUpdate} showDisconnect={true}/></div>
                        {account.canDelete ? 
                        <button data-toggle="modal" data-target={hashPopupId} className="btn btn-default icons-list-item" title={t("btndelete")}><i className="fa fa-trash"></i></button>
                        : 
                        ""}
                        <div className="modal fade" id={popupId} tabIndex="-1" role="dialog" aria-labelledby={popupLabelId} aria-hidden="true">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id={popupLabelId}>{t("lbldeleteconfirm")}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label={t("btnclose")} title={t("btnclose")}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        {t("lblappdeleteconfirm")}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="submit-btn" data-dismiss="modal" onClick={this.onDelete} data-accountid={accountId}>{t("btndeleteconfirm")}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br/><br/>
                    </div>
                )
            }
        }
        return (
            <div className="account-list">
                {accountItems}
            </div>
        )
    }

}

export default withTranslation()(AccountsList)